<template>
  <div>
    <page-header title="Billings" breadcrumb="Billings & Collections > Billings" />
    <section class="bg-white my-4 p-3">
      <div class="flex border-b-2 bg-primary-lightgrey pt-2">
        <div class="tab-item" :class="{ active: currentTab == 'private' }" @click="currentTab = 'private'">
          <p>Private</p>
        </div>
        <div class="tab-item" :class="{ active: currentTab == 'corporate' }" @click="currentTab = 'corporate'">
          <p>Enterprise</p>
        </div>
      </div>

      <div class="my-4">
        <button @click="sectionTab = 'active'" class="section_item" :class="{ active: sectionTab == 'active' }">
          Active
        </button>
        <button @click="sectionTab = 'quote'" class="section_item" :class="{ active: sectionTab == 'quote' }">
          Quotes & Drafts
        </button>
        <button @click="sectionTab = 'payment'" class="section_item" :class="{ active: sectionTab == 'payment' }">
          Payments
        </button>
        <button v-if="$_isDevelopment" @click="sectionTab = 'recievable'" class="section_item"
          :class="{ active: sectionTab == 'recievable' }">
          Account Receivables
        </button>
      </div>

      <div class="flex py-4 justify-between">
        <div class="unit-point">
          <p class="w-full">Transaction Count: {{
            allTransactionProperty.totalCount
              ? allTransactionProperty.totalCount
              : "0"
          }}</p>
          <span class="w-12"><img src="@/assets/images/billing/total_value.svg" /></span>
        </div>
        <div class="unit-point">
          <p class="w-full">
            Total Value: ₦
            {{
              allTransactionProperty.totalTransactionValue
                ? allTransactionProperty.totalTransactionValue.toLocaleString()
                : "0"
            }}
          </p>
          <span class="w-12"><img src="@/assets/images/billing/total_value.svg" /></span>
        </div>
      </div>

      <div v-if="sectionTab == 'quote'"
        class="w-full py-3 px-4 rounded-xl bg-primary-yellow/30 border-[2px] border-primary-yellow my-4">
        The system will automatically delete drafts after 3 months, if not edited.
      </div>

      <TableFilter @setQueryparams="sortItemProps" :activeTab="sectionTab" />
      <div v-loading="loading">
        <TableBase :activeTab="sectionTab" :tableContent="allTransaction" :currentTab="currentTab"
          @refetchTransactions="getAllTransaction()" />
      </div>
      <PaginationControl :total="totalTransaction" :pageNumber="sortOptions.pageNumber"
        @pageNumber="setPageDisplayTransaction" @pageSize="setNumDisplayTransaction" />
    </section>
  </div>
</template>

<script>
import moment from "moment";
import TableFilter from "../modules/TableFilter.vue";
import TableBase from "../modules/TableBase.vue";
import PageHeader from "@/components/UI/NewPageHeader";
import PaginationControl from "@/components/UI/pagination";

export default {
  components: {
    TableFilter,
    TableBase,
    PageHeader,
    PaginationControl,
  },
  data() {
    return {
      currentTab: "private",
      totalTransaction: null,
      sectionTab: 'active',
      loading: true,
      sortOptions: {
        pageSize: 10,
        pageNumber: 1,
        startDate: null,
        endDate: null,
        searchString: "",
        interval: 'month'
      },
      allTransaction: [],
      allTransactionProperty: {},
    };
  },
  computed: {
    payload() {
      return {
        pageSize: this.sortOptions.pageSize,
        pageNumber: this.sortOptions.pageNumber,
        type: this.currentTab,
        searchTerm: this.sortOptions.searchString,
        status: this.sectionTab,
        interval: this.sortOptions.interval,
        statusFilter: this.sortOptions.statusFilter,
        startDate:
          this.sortOptions.startDate != null
            ? moment(this.sortOptions.startDate).format("YYYY-MM-DD")
            : "",
        endDate:
          this.sortOptions.endDate != null
            ? moment(this.sortOptions.endDate).format("YYYY-MM-DD")
            : "",
      };
    },
  },
  watch: {
    sortOptions() {
      this.getAllTransaction();
    },
    payload() {
      this.getAllTransaction();
    },
    sectionTab(val) {
      this.setActiveRouteOnmount(val)
    },
    currentTab() {
      this.setRouteQuery(this.sectionTab)
    }
  },
  mounted() {
    this.currentTab = this.$route?.query?.section || 'private';
    this.getAllTransaction();
    this.setActiveRouteOnmount(this.$route?.query?.tab);
  },
  methods: {
    setRouteQuery(val) {
      let currentQuery = this.$route.query;
      let newQuery = { ...currentQuery, tab: val, section: this.currentTab };
      this.$router.push({ query: newQuery });
    },
    setActiveRouteOnmount(val) {
      switch (val) {
        case 'active':
          this.sectionTab = 'active'
          break;

        case 'quote':
          this.sectionTab = 'quote'
          break;

        case 'payment':
          this.sectionTab = 'payment'
          break;

        case 'recievable':
          this.sectionTab = 'recievable'
          break;

        default:
          this.sectionTab = 'active'
          break;
      }
      this.setRouteQuery(val)
    },
    setNumDisplayTransaction(val) {
      this.sortOptions = { ...this.sortOptions, pageSize: val };
    },
    setPageDisplayTransaction(val) {
      this.sortOptions = { ...this.sortOptions, pageNumber: val };
    },
    sortItemProps(val) {
      console.log("sortItemProps", val);
      this.sortOptions = { ...this.sortOptions, ...val };
    },
    async getAllTransaction() {
      this.loading = true;
      try {
        let response = await this.$_getAllBillings(this.payload);
        this.allTransaction = response.data?.data?.shippings;

        this.totalTransaction = response.data?.data.totalCount;
        this.allTransactionProperty = response.data?.data;

      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-item {
  cursor: pointer;
  // margin-right: 1rem;
  color: #5e646d;
  padding: 0.25rem 1.5rem;
  font-size: 0.9rem;
  @apply bg-gray-300;

  &.active {
    background: #ffffff;
    @apply shadow-xl;
    border-radius: 5px;
    color: #fcc210;
    font-weight: bold;
  }
}

.section_item {
  @apply py-1 px-4 bg-primary-lighterblue rounded mr-3;
  transition: all 0.30s;

  &.active {
    @apply bg-primary-navy text-white;
  }
}

.unit-point {
  @apply flex shadow-xl px-4 py-4 rounded-lg items-center;
  width: 47%;
}
</style>
